import React from "react";

const Address = ({ address }) => {
  let text;
  if (!address) {
    return null;
  }

  if (address.city) {
    if (address.state) {
      text = ` ${address.state.label}`;
    }
    text += `, ${address.city.label}`;
  } else {
    if (address.country) {
      text = ` ${address.country.label},`;
    }
    if (address.state) {
      text += ` ${address.state.label}`;
    }
  }
  return (
    <span>
      <i className="fa fa-map-marker" /> {text}
    </span>
  );
};

export default Address;



// WEBPACK FOOTER //
// ./src/_components/UI/UserWidget/Address/index.js